var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Thank you")]),_c('b-button',{staticClass:"btn-success",on:{"click":_vm.close}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }